import React from 'react';
import { checkNetworkHealth } from '../../services/systemService';
import {
  reportApiUnreachable,
  reportBrowserOffline,
  reportOnline,
} from '../../services/connectivityService';

const POLL_MS = 15000;

/**
 * Background API reachability poll via /system/ping (works before and after login).
 */
class ConnectivityProbe extends React.Component {
  intervalId = null;
  inFlight = false;

  componentDidMount() {
    this.check({ immediate: true });
    this.intervalId = window.setInterval(() => this.check(), POLL_MS);
    window.addEventListener('online', this.handleBrowserOnline);
    window.addEventListener('offline', this.handleBrowserOffline);
  }

  componentWillUnmount() {
    if (this.intervalId) window.clearInterval(this.intervalId);
    window.removeEventListener('online', this.handleBrowserOnline);
    window.removeEventListener('offline', this.handleBrowserOffline);
  }

  handleBrowserOnline = () => {
    this.check({ immediate: true });
  };

  handleBrowserOffline = () => {
    reportBrowserOffline();
  };

  check = async ({ immediate = false } = {}) => {
    if (this.inFlight) return;
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      reportBrowserOffline();
      return;
    }

    this.inFlight = true;
    try {
      const { data } = await checkNetworkHealth();
      const ok = data === true || data?.ok === true || data?.status === true;
      if (ok) {
        reportOnline({ immediate });
      } else {
        reportApiUnreachable();
      }
    } catch (err) {
      reportApiUnreachable();
    } finally {
      this.inFlight = false;
    }
  };

  render() {
    return null;
  }
}

export default ConnectivityProbe;
